import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=0886db84&scoped=true&"
import script from "./questions.vue?vue&type=script&lang=js&"
export * from "./questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0886db84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0886db84')) {
      api.createRecord('0886db84', component.options)
    } else {
      api.reload('0886db84', component.options)
    }
    module.hot.accept("./questions.vue?vue&type=template&id=0886db84&scoped=true&", function () {
      api.rerender('0886db84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/medical-manage/health-manage/questions.vue"
export default component.exports